import React from 'react';
import { string } from 'prop-types';
import Button from '../../../../../components/shared/Button';

const FollowButton = ({ className, text, href }) => {
  return (
    <Button
      classes={className}
      variant="primary"
      onClick={() => console.log('TODO: wire up this button https://alltrails.atlassian.net/browse/SVR-4476')}
    >
      {text}
    </Button>
  );
};

FollowButton.propTypes = {
  className: string,
  text: string.isRequired,
  href: string.isRequired
};

FollowButton.defaultProps = {
  className: ''
};

export default FollowButton;
